import { render, staticRenderFns } from "./AudienceSegment.vue?vue&type=template&id=68939934&scoped=true&"
import script from "./AudienceSegment.vue?vue&type=script&lang=ts&"
export * from "./AudienceSegment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68939934",
  null
  
)

export default component.exports